export default {"src":"/_next/static/media/ZI.37beee55.svg","height":18,"width":18};